import RouteUtils from '~/core/utils/RouteUtils';

import {policyPaths} from '~/paths';

const routes = [
	{
		path: policyPaths.policyEditBusinessPagePattern,
		title: 'Edit Policy Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyBusinessDetailsPage');
		}),
	},
	{
		path: policyPaths.policyEditWagesPagePattern,
		title: 'Edit Policy Wages',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyWagesPage');
		}),
	},
	{
		path: policyPaths.policyEditChangePagePattern,
		title: 'Edit Policy Confirmation',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/ChangeConfirmationPage');
		}),
	},
	{
		path: policyPaths.policyEditPremiumPagePattern,
		title: 'Edit Policy Details',
		isDynamicRouteRequired: true,
		requiresAuth: false,
		requiredRole: false,
		component: RouteUtils.asyncComponent(() => {
			return import('./pages/PolicyPremiumPage');
		}),
	},
];

export default routes;
